import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

const ResetPasswordScreen = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get("token");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (!password || !confirmPassword) {
      return setMessage("Remplissez tous les champs");
    }

    if (password !== confirmPassword) {
      return setMessage("Les mots de passe ne correspondent pas");
    }

    try {
      setLoading(true);
      setMessage("");

      const response = await fetch(
        "https://api.joss-serveur.duckdns.org/auth/reset-password",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            token,
            password,
          }),
        }
      );

      const data = await response.json();

      if (data.success) {
        setMessage("Mot de passe réinitialisé avec succès");

        setTimeout(() => {
          navigate("/login");
        }, 2000);
      } else {
        setMessage(data.message || "Erreur");
      }
    } catch (err) {
      console.error(err);
      setMessage("Erreur serveur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background:
  "linear-gradient(180deg, #F4F0FA 0%, #E6DDF4 100%)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 20,
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 400,
          background: "rgba(255,255,255,0.92)",
          border: "1px solid rgba(143,174,93,0.20)",
          padding: 30,
          borderRadius: 16,
          boxShadow: "0 0 20px rgba(0,0,0,0.4)",
        }}
      >
        <h1
          style={{
            color: "#3B3450",
            textAlign: "center",
            marginBottom: 30,
          }}
        >
          Nouveau mot de passe
        </h1>

        <form onSubmit={handleResetPassword}>
          <input
            type="password"
            placeholder="Nouveau mot de passe"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{
              width: "100%",
              padding: 14,
              marginBottom: 15,
              borderRadius: 10,
              background: "rgba(255,255,255,0.95)",
              color: "#3B3450",
              border: "1px solid rgba(143,174,93,0.25)",
              fontSize: 16,
            }}
          />

          <input
            type="password"
            placeholder="Confirmer le mot de passe"
            value={confirmPassword}
            onChange={(e) =>
              setConfirmPassword(e.target.value)
            }
            style={{
              width: "100%",
              padding: 14,
              marginBottom: 20,
              borderRadius: 10,
              background: "rgba(255,255,255,0.95)",
              color: "#3B3450",
              border: "1px solid rgba(143,174,93,0.25)",
              fontSize: 16,
            }}
          />

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: 14,
              borderRadius: 10,
              border: "none",
              background:
                 "linear-gradient(135deg, #8FAE5D, #9AB86A)",
              color: "#fff",
              fontWeight: "bold",
              fontSize: 16,
              cursor: "pointer",
            }}
          >
            {loading
              ? "Chargement..."
              : "Réinitialiser"}
          </button>
        </form>

        {message && (
          <p
            style={{
              color: "#3B3450",
              marginTop: 20,
              textAlign: "center",
            }}
          >
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default ResetPasswordScreen;